"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpsertSellerDto = instanceOfUpsertSellerDto;
exports.UpsertSellerDtoFromJSON = UpsertSellerDtoFromJSON;
exports.UpsertSellerDtoFromJSONTyped = UpsertSellerDtoFromJSONTyped;
exports.UpsertSellerDtoToJSON = UpsertSellerDtoToJSON;
exports.UpsertSellerDtoToJSONTyped = UpsertSellerDtoToJSONTyped;
/**
 * Check if a given object implements the UpsertSellerDto interface.
 */
function instanceOfUpsertSellerDto(value) {
    if (!('sellerId' in value) || value['sellerId'] === undefined)
        return false;
    return true;
}
function UpsertSellerDtoFromJSON(json) {
    return UpsertSellerDtoFromJSONTyped(json, false);
}
function UpsertSellerDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sellerId': json['sellerId'],
    };
}
function UpsertSellerDtoToJSON(json) {
    return UpsertSellerDtoToJSONTyped(json, false);
}
function UpsertSellerDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sellerId': value['sellerId'],
    };
}
